import firebase from "../firebase";

const minuteLogs = firebase.ref("/minuteLogs");

class MinuteLogService {
    getAll(userInfo) {
        return minuteLogs.orderByChild("IsDeleted").equalTo(0);
    }

    getById(Id) {
        var ref = minuteLogs.child("/" + Id);
        return ref;
    }

    create(minutelog) {
        var newPostRef = minuteLogs.push();
        var Id = newPostRef.key;
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        minutelog["Id"] = Id;
        minutelog["CreatedDate"] = minutelog[
        "ModifiedDate"
        ] =  UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

        return minuteLogs.child(Id).set(minutelog);
    }

    update(key, minutelog) {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        minutelog["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone,);
        return minuteLogs.child(key).update(minutelog);
    }

    delete(key) {
        return minuteLogs.child(key).update({
            IsDeleted: 1
        });
    }
}

export default new MinuteLogService();
